import { Component, Input, OnInit } from '@angular/core';
import { UpdateAlert } from '@classes/alert/alert';
import { faCircle as faBouboule } from '@fortawesome/free-solid-svg-icons';
import { alertService } from '@services/alert/alert.service';


@Component({
  selector: 'app-form-status',
  templateUrl: './form-status.component.html',
  styleUrls: ['./form-status.component.scss']
})
export class FormStatusComponent implements OnInit {
  @Input() element: any;
  @Input() level: string[]

  faBouboule = faBouboule;


  constructor(
    private alertService: alertService
  ) { }

  ngOnInit(): void {
  }

  getStatusRoute(status: any): string {
    let Statut: string = '';
    switch (status) {
      case 'Low':
        Statut = 'components.smartwaste.historique.Low.label'
        break;
      case 'Medium':
        Statut = 'components.smartwaste.historique.Medium.label'
        break;
      case 'High':
        Statut = 'components.smartwaste.historique.High.label'
        break;

      default:
        break;
    }

    return Statut
  }

  putAlertLevel(id: string, event): void {
    const status = new UpdateAlert(event.value)
    this.alertService.putAlert(id, status).subscribe(() => { });
  }

  getColorStatusSelected(): number {

    const status = {
      'Low': 0,
      'Medium': 1,
      'High': 2,
    }


    return status[this.element.status];

  }

}
